import React, { Component, Fragment } from "react";
import AutoInput from "../containers/AutoInput";
import { getBelongsToValue } from "../utils/models";
import { getValue } from "../utils/models";
import withValues from "../hocs/withValues";

class ProfitAndLosesCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      proveedor: "",
      material: "",
      customerid: ""
    };
  }

  render() {
    return (
      <Fragment>
            <AutoInput
              form={this.props.form}
              model={"profitandloses"}
              attribute={"proveedor"}
              onChange={value => {
                this.setState({ proveedor: value });
              }}
              value={getValue(this.props.values, "proveedor")}
            />
            <AutoInput
              form={this.props.form}
              model={"profitandloses"}
              attribute={"material"}
              placeholder={"Select Service"}
              onChange={value => {
                this.setState({ material: value });
              }}
              value={getValue(this.props.values, "material")}
            />
            <AutoInput
              form={this.props.form}
              model={"profitandloses"}
              attribute={"montoCompra"}
              value={getValue(this.props.values, "montoCompra")}
            />
            <AutoInput
              form={this.props.form}
              model={"profitandloses"}
              type={"model"}
              attribute={"divisaCompra"}
              items={["USD", "MXN"]}
              value={getValue(this.props.values, "divisaCompra")}
            />

            <AutoInput
              form={this.props.form}
              model={"profitandloses"}
              attribute={"folioCompra"}
              value={getValue(this.props.values, "folioCompra")}
            />
            <AutoInput
              form={this.props.form}
              model={"profitandloses"}
              attribute={"customerId"}
              onChange={value => {
                this.setState({ customerid: value });
              }}
              value={getValue(this.props.values, "customerId")}
            />
            <AutoInput
              form={this.props.form}
              model={"profitandloses"}
              attribute={"montoVenta"}
              value={getValue(this.props.values, "montoVenta")}
            />
            <AutoInput
              form={this.props.form}
              model={"profitandloses"}
              attribute={"folioVenta"}
              value={getValue(this.props.values, "folioVenta")}
            />

            <AutoInput
              form={this.props.form}
              model={"quote"}
              attribute={"quote"}
              value={getBelongsToValue("quote", this.props.belongsTo)}
              hidden
            />
      </Fragment>
    );
  }
}

export default withValues(ProfitAndLosesCreate);



// WEBPACK FOOTER //
// ./src/forms/ProfitAndLosesEdit.js